/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CheckEquipment from '@/components/CheckEquipment';
import { hdprojectproductInfo, addcomplaint } from '@/api';
import XInput from "vux/src/components/x-input/index.vue";
import Group from "vux/src/components/group/index.vue";
import XTextarea from "vux/src/components/x-textarea/index.vue";
import XButton from "vux/src/components/x-button/index.vue";
export default {
  name: 'complaint',
  components: {
    CheckEquipment: CheckEquipment,
    XInput: XInput,
    Group: Group,
    XTextarea: XTextarea,
    XButton: XButton
  },
  data: function data() {
    return {
      project_id: '',
      isShowCheckEquipment: false,
      id: localStorage.getItem('id'),
      form: {
        hdProducts: []
      },
      productname: '',
      product_code: '',
      neirong: '',
      xingming: '',
      telephone: '',
      fkTProductionId: ''
    };
  },
  methods: {
    getList: function getList(e) {
      if (!e) return;
      e.map(function (val) {
        return val.product_name = val.name, val.fk_t_hd_project_production_id = val.value, val.id = val.value;
      });
      this.form.hdProducts = this.form.hdProducts.concat(JSON.parse(JSON.stringify(e)));
      this.productname = this.form.hdProducts[0].product_code;
      this.fkTProductionId = this.form.hdProducts[0].id;
    },
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return hdprojectproductInfo(_this.id);

              case 2:
                res = _context.sent;
                console.log(res);

                if (res.data.code === 0) {
                  _this.fkTProductionId = _this.id;
                  _this.productname = res.data.hdProjectProduct.production_code;
                  _this.project_id = res.data.hdProjectProduct.project_id;
                  _this.product_code = res.data.hdProjectProduct.project_contract_no;
                } else {
                  _this.$vux.toast.text(res.msg);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    isShowCheckEquipment1: function isShowCheckEquipment1() {
      this.isShowCheckEquipment = true;
      this.$refs.CheckEquipment.loadList(true);
    },
    tijiao: function tijiao() {
      var _this2 = this;

      if (this.neirong == '' || this.xingming == '' || this.telephone == '') {
        this.$vux.toast.text('请填写完整信息');
        return;
      }

      var data = {
        source: 4,
        fkTProductionId: this.fkTProductionId,
        fkTProjectId: this.project_id,
        content: this.neirong,
        name: this.xingming,
        phone: this.telephone
      };
      console.log(data);
      addcomplaint(data).then(function (res) {
        if (res.data.code == 0) {
          _this2.$vux.toast.text('提交成功');

          _this2.$router.back();
        } else {
          _this2.$vux.toast.text(res.data.msg);
        }
      });
    }
  },
  created: function created() {
    this.init();
  }
};